import * as React from 'react';
import styles from '../../styles/row.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Row = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles['row'],
    children: children
  });
};
Row.displayName = 'Row';